var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#25D366",
    d: "M16 29.334c7.364 0 13.333-5.97 13.333-13.334S23.363 2.667 16 2.667 2.667 8.637 2.667 16c0 2.133.5 4.15 1.39 5.937.238.475.316 1.018.18 1.53l-.795 2.969c-.345 1.288.834 2.467 2.122 2.122l2.969-.794a2.18 2.18 0 0 1 1.53.178A13.3 13.3 0 0 0 16 29.334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 16a1.333 1.333 0 1 0 2.667 0A1.333 1.333 0 0 0 20 16M14.667 16a1.333 1.333 0 1 0 2.666 0 1.333 1.333 0 0 0-2.666 0M9.333 16A1.333 1.333 0 1 0 12 16a1.333 1.333 0 0 0-2.667 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.ae3d5ace9e8f209fe812594c7da12725.svg";
export { ForwardRef as ReactComponent };